import script from "./TransportsWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransportsWidget.vue?vue&type=script&setup=true&lang=ts"

import "./TransportsWidget.vue?vue&type=style&index=0&id=539c8d66&scoped=true&lang=css"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-539c8d66"]])

export default __exports__